import React from 'react';

import SocialLink from './Social';
import TwitterIcon from '../icons/Twitter';

import classes from '../Footer.scss';

export default function TwitterLink(props) {
  return (
    <SocialLink
      href  = "https://twitter.com/CityAds_Global"
      title = "Twitter"
      {...props}
    >
      <TwitterIcon className={classes.socialIcon} />
    </SocialLink>
  );
}